import React, { useEffect, useState } from 'react';
import { FaEye } from 'react-icons/fa';
import '../../styles/user/submittedVerification.css';
import { fetchSubmittedCandidates } from '../../services/user/api';
import { Search, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const SubmittedVerificationPage = ({ onViewReportTwo }) => {
 const navigate = useNavigate();
  const [candidates, setCandidates] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [entriesPerPage, setEntriesPerPage] = useState(10);


  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState('');
  const [isAsc, setIsAsc] = useState(true);

  const totalPages = Math.ceil(totalElements / entriesPerPage);



  const loadSubmittedCandidates = async () => {
    try {
      setLoading(true);
      setFetchError(null);

      const response = await fetchSubmittedCandidates(
        currentPage,
        entriesPerPage,
        search,
        sortField,
        sortOrder
      );

      if (response?.data?.status) {
        const data = response.data.data;
        setCandidates(data.content || []);
        setTotalElements(data.totalElements || 0);
      } else {
        setFetchError(response.data.message || 'Failed to fetch submitted candidates.');
      }

    } catch (error) {
      setFetchError('An error occurred while fetching data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSubmittedCandidates();
  }, [currentPage, entriesPerPage, search, sortField, sortOrder]);



  // handle the sort with consistency icons and defualt sort asc . 
  const handleSort = (column) => {
    if (sortField === column) {
      // Same column -> toggle
      const newIsAsc = !isAsc;
      setIsAsc(newIsAsc);
      setSortOrder(newIsAsc ? "asc" : "desc");
    } else {
      // Different column -> default to ascending
      setSortField(column);
      setIsAsc(true);
      setSortOrder("asc");
    }

    setCurrentPage(0);
  };



  const renderSortArrow = (field) => {
    const isActive = sortField === field;

    return (
      <span
        className={`sort-icons ${isActive ? "sort-active" : ""
          }`}
      >
        {/* showing the next action button  */}
        {!isActive
          ? "▲▼"
          : sortOrder === "asc"
            ? "▲" : "▼" 
        }
      </span>
    );
  };





  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'verified':
        return 'status-tag verified';
      case 'completed':
        return 'status-tag completed';
      case 'work in progress':
        return 'status-tag work-in-progress';
      case 'login expired':
        return 'status-tag login-expired';
      case 'yet to start':
        return 'status-tag pending-submission';
      default:
        return 'status-tag';
    }
  };

 return (
  <>
    {/* Back Button */}
    <div className="submitted-verification-back-wrapper">
      <button
        type="button"
        className="submitted-verification-back-button"
        onClick={() => navigate(-1)}
      >
        <ArrowLeft size={18} />
        <span>Back</span>
      </button>
    </div>

    <p className="client-header">Submitted for Verification</p>

    <div className="client-wrapper">

        <div className="clinet-table-controls">
          <div className="entries-select">
            Show{' '}
            <select
              value={entriesPerPage}
              onChange={(e) => {
                setEntriesPerPage(Number(e.target.value));
                setCurrentPage(0);
              }}
            >
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>{' '}
            entries
          </div>

          <div className="client-search-box">
            <div className="client-search-input-wrapper">
              <input
                id="client-search-input"
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(0);
                }}
                placeholder="Search by any field..."
              />
              <Search className="client-search-icon" size={18} />
            </div>
          </div>
        </div>

        {fetchError && <div className="error-message">{fetchError}</div>}

        <div className="clinet-table-container">
          <table className="candidates-clinet-table">
            <colgroup>
              <col style={{ width: "130px" }} />
              <col style={{ width: "180px" }} />
              <col style={{ width: "220px" }} />
              <col style={{ width: "150px" }} />
              <col style={{ width: "120px" }} />
              <col style={{ width: "140px" }} />
              <col style={{ width: "130px" }} />
              <col style={{ width: "160px" }} />
              <col style={{ width: "100px" }} />
            </colgroup>
            <thead>
              <tr>
                <th onClick={() => handleSort('candidateid')}>
                  Candidate ID {renderSortArrow('candidateid')}
                </th>
                <th onClick={() => handleSort('fullname')}>
                  Name {renderSortArrow('fullname')}
                </th>
                <th onClick={() => handleSort('email')}>
                  Email {renderSortArrow('email')}
                </th>
                <th onClick={() => handleSort('mobileNumber')}>
                  Mobile Number {renderSortArrow('mobileNumber')}
                </th>
                <th onClick={() => handleSort('dateOfBirth')}>
                  DOB {renderSortArrow('dateOfBirth')}
                </th>
                <th onClick={() => handleSort('caseInitiatedDateOnlyAsString')}>
                  Created Date {renderSortArrow('caseInitiatedDateOnlyAsString')}
                </th>
                <th>
                  Created Time
                </th>
                <th onClick={() => handleSort('bgcStatus')}>
                  Status {renderSortArrow('bgcStatus')}
                </th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="loading">
                    Loading Candidates...
                  </td>
                </tr>
              ) : candidates.length > 0 ? (
                candidates.map((candidate) => (
                  <tr key={candidate.candidateid}>
                    <td>{candidate.candidateid}</td>
                    <td>{candidate.fullname}</td>
                    <td>{candidate.email}</td>
                    <td>{candidate.mobileNumber}</td>
                    <td>{candidate.dateOfBirth}</td>
                    <td>{candidate.caseInitiatedDateOnlyAsString || 'N/A'}</td>
                    <td>{candidate.caseInitiatedTimeOnly || 'N/A'}</td>
                    <td>
                      <span className={getStatusClass(candidate.bgcStatus)}>
                        {candidate.bgcStatus || 'N/A'}
                      </span>
                    </td>
                    <td className="client-action-btn">
                      <button
                        className="client-action-btn"
                        onClick={() => onViewReportTwo(candidate.candidateid)}
                        title="View Report"
                      >
                        <FaEye />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="no-data">
                    No candidates found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>


        {totalElements > 0 && (
          <div className="pagination">
            <div className="pagination-summary">
              Showing {currentPage * entriesPerPage + 1} to{' '}
              {Math.min((currentPage + 1) * entriesPerPage, totalElements)} of{' '}
              {totalElements} entries
            </div>

            <div className="pagination-buttons-user">
              <button
                className="page-btn"
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 0))}
                disabled={currentPage === 0}
              >
                ←
              </button>

              <button className="page-btn active">
                {currentPage + 1}
              </button>

              <button
                className="page-btn"
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages - 1))}
                disabled={currentPage === totalPages - 1}
              >
                →
              </button>
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default SubmittedVerificationPage;